import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useTheme } from '@/hooks/use-theme';
import { cn } from '@/lib/utils';
import { LaptopMinimal, Moon, Sun } from 'lucide-react';

interface ThemeToggleProps {
  variant?: 'sidebar' | 'header';
  className?: string;
}

export function ThemeToggle({ variant = 'header', className }: ThemeToggleProps) {
  const { theme, setTheme, isDark, isSystemTheme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn(
            'h-9 w-9 rounded-lg transition-colors',
            variant === 'sidebar'
              ? 'border-sidebar-border/70 bg-sidebar-muted/65 text-sidebar-foreground/85 hover:bg-sidebar-muted hover:text-sidebar-foreground border shadow-sm'
              : 'text-foreground/70 hover:text-foreground hover:bg-muted',
            className,
          )}
        >
          {isSystemTheme ? (
            <LaptopMinimal className="h-5 w-5" />
          ) : isDark ? (
            <Sun className="h-5 w-5" />
          ) : (
            <Moon className="h-5 w-5" />
          )}
          <span className="sr-only">Tema</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuLabel>Tema</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup value={theme ?? 'system'} onValueChange={setTheme}>
          <DropdownMenuRadioItem value="system">Usar sistema</DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="light">Claro</DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="dark">Escuro</DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
